/**
 * OperatorDecisionPanels — the Risk Center top-of-page section that surfaces
 * operational decision visibility:
 *   - Account Supervision alerts (most prominent, top of stack)
 *   - Strategy Status
 *   - Council Review Queue
 *   - Account History (performance + lockouts, read-only)
 *
 * All panels are read-only and gracefully render LIMITED / UNAVAILABLE if a
 * backing endpoint is missing or has not produced a run yet.
 */
import React from "react";
import SupervisionAlertsBanner from "./SupervisionAlertsBanner";
import StrategyStatusPanel from "./StrategyStatusPanel";
import CouncilReviewQueuePanel from "./CouncilReviewQueuePanel";
import AccountHistorySection from "./AccountHistorySection";

export default function OperatorDecisionPanels() {
  return (
    <div data-testid="operator-decision-panels" className="space-y-4">
      <SupervisionAlertsBanner />
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <StrategyStatusPanel />
        <CouncilReviewQueuePanel />
      </div>
      <AccountHistorySection />
    </div>
  );
}
